import 'ag-grid-community/dist/styles/ag-grid.css';
import 'ag-grid-community/dist/styles/ag-theme-material.css';
import { AgGridColumn, AgGridReact } from 'ag-grid-react';
import React, { Component } from 'react';
import SourceNameCellRenderer from './SourceNameCellRenderer';
import Constants from '../Constants';

export default class SourcesGrid extends Component {
    static displayName = SourcesGrid.name;

    render() {
        return (
            <div className="ag-theme-material" style={{ height: window.innerHeight - 150, width: "100%" }}>
                <AgGridReact
                    quickFilterText={this.props.quickFilterText}
                    rowData={this.props.sources}
                    enableCellTextSelection={true}
                    suppressCellSelection={true}
                    suppressDragLeaveHidesColumns={true}
                    suppressScrollOnNewData={true}
                    defaultColDef={{
                        resizable: true,
                        sortable: true,
                        filter: true
                    }}>
                    <AgGridColumn field="id" width={100}></AgGridColumn>
                    <AgGridColumn field="name"
                        minWidth={350}
                        cellRendererFramework={SourceNameCellRenderer}
                        cellRendererParams={{ linkClicked: this.props.linkClicked }}
                    >
                    </AgGridColumn>
                    <AgGridColumn
                        field="sourceTypeName"
                        headerValueGetter={() => "Source Type"}
                        valueGetter={(params) => Constants.getSourceTypeDisplayName(params.data)}
                        width={280}>
                    </AgGridColumn>
                    <AgGridColumn
                        field="hasInPlay"
                        valueGetter={(params) => Constants.AvailabilityTypes.find(a => a.id === params.data.hasInPlay)?.name}
                        width={140}
                        headerValueGetter={() => "Has In-Play"}>
                    </AgGridColumn>
                    <AgGridColumn
                        field="hasPreMatch"
                        valueGetter={(params) => Constants.AvailabilityTypes.find(a => a.id === params.data.hasPreMatch)?.name}
                        width={150}
                        headerValueGetter={() => "Has Pre-Match"}>
                    </AgGridColumn>
                    <AgGridColumn
                        field="hasMarkets"
                        valueGetter={(params) => Constants.AvailabilityTypes.find(a => a.id === params.data.hasMarkets)?.name}
                        width={140}
                        headerValueGetter={() => "Has Markets"}>
                    </AgGridColumn>
                    <AgGridColumn field="maintainer"></AgGridColumn>
                </AgGridReact>
            </div>
        );
    }
}
